import { takeEvery, put, call } from 'redux-saga/effects';

import alerts from 'src/app/alerts.json';
import resetApi from 'src/app/api/resetApi';
import {
  EMAIL_SEND,
  EMAIL_SEND_RETRY,
  resetEmailSetSending,
  resetEmailSetSent
} from 'src/app/redux/actions/reset/resetEmailSend';
import {
  feedbackMessageHide,
  feedbackMessageShow
} from 'src/app/redux/actions/feedbackMessage';
import { resetEmailSetApiError } from 'src/app/redux/actions/reset/resetEmail';
import { apiAskForResetEmailError } from 'src/app/redux/actions/apiError';
import getWindowSearchParam from 'src/app/api/getWindowSearchParam';


function sendResetEmail(remindPasswordRequest, retry, returnUrl) {
  return function* sendResetEmailGenerator({ payload }) {
    const { value } = payload;

    yield put(resetEmailSetApiError(false));
    yield put(feedbackMessageHide());
    yield put(resetEmailSetSending(true));

    const sendResetEmailRequest = yield remindPasswordRequest({ email: value, returnUrl })
      .then(function* onSuccess() {
        if (retry) {
          yield put(feedbackMessageShow(alerts.resentActivationLink));
        }

        return yield put((resetEmailSetSent(true)));
      })
      .catch(function* onError({ response }) {
        yield put(resetEmailSetApiError(true));

        yield put(apiAskForResetEmailError(response));
        yield put(resetEmailSetSending(false));

        if (retry) {
          yield put((resetEmailSetSent(false)));
        }
      });

    yield call(() => sendResetEmailRequest);
  };
}

export default [
  takeEvery(EMAIL_SEND, sendResetEmail(resetApi.remindPassword, false, getWindowSearchParam('returnUrl'))),
  takeEvery(EMAIL_SEND_RETRY, sendResetEmail(resetApi.remindPassword, true, getWindowSearchParam('returnUrl')))
];
